import type { RouteObject } from "react-router-dom";
import { page } from "@/app/page";
import { SettingsPage } from "@/nav/SettingsPage";
import { WaterContextProvider } from "@/screens/legionella/context";

const settingsScreens = {
  "asset-types": page(() => import("@/screens/legionella/AssetTypes")),
  "programmes": page(() => import("@/screens/legionella/Programmes")),
  "compliance-bands": page(() => import("@/screens/legionella/ComplianceBands")),
  "working-days": page(() => import("@/screens/legionella-settings/WorkingDays")),
  "reminders": page(() => import("@/screens/legionella/Reminders")),
  "ra-sections": page(() => import("@/screens/legionella-settings/RaSections")),
  "thermometers": page(() => import("@/screens/legionella-settings/Thermometers")),
};

const settings = <WaterContextProvider><SettingsPage itemId="water-settings" screens={settingsScreens} /></WaterContextProvider>;

export const waterRoutes: RouteObject[] = [
  {
    path: "/legionella",
    element: page(() => import("@/screens/legionella/Layout")),
    children: [
      { id: "water.dashboard", index: true, element: page(() => import("@/screens/legionella/Dashboard")) },
      { id: "water.calendar", path: "calendar", element: page(() => import("@/screens/legionella/Calendar")) },
      { id: "water.clients", path: "clients", element: page(() => import("@/screens/legionella/Clients")) },
      { id: "water.sites", path: "sites", element: page(() => import("@/screens/legionella/Sites")) },
      { id: "water.locations", path: "locations", element: page(() => import("@/screens/legionella/Locations")) },
      { id: "water.systems", path: "systems", element: page(() => import("@/screens/legionella/Systems")) },
      { id: "water.system", path: "systems/:id", element: page(() => import("@/screens/legionella/SystemDetail")) },
      { id: "water.schematic", path: "schematic", element: page(() => import("@/screens/legionella/WaterSchematic")) },
      { id: "water.assets", path: "assets", element: page(() => import("@/screens/legionella/Assets")) },
      { id: "water.asset", path: "assets/:id", element: page(() => import("@/screens/legionella/AssetDetail")) },
      { id: "water.work-orders", path: "work-orders", element: page(() => import("@/screens/legionella/WorkOrders")) },
      { id: "water.work-order", path: "work-orders/:id", element: page(() => import("@/screens/legionella/WorkOrderDetail")) },
      { id: "water.schedules", path: "schedules", element: page(() => import("@/screens/legionella/Schedules")) },
      { id: "water.alerts", path: "alerts", element: page(() => import("@/screens/legionella/Alerts")) },
      { id: "water.risk-assessments", path: "risk-assessments", element: page(() => import("@/screens/legionella/RiskAssessments")) },
      { id: "water.risk-assessment", path: "risk-assessments/:id", element: page(() => import("@/screens/legionella/RiskAssessmentDetail")) },
      { id: "water.non-conformities", path: "non-conformities", element: page(() => import("@/screens/legionella/NonConformities")) },
      { id: "water.site-action-reports", path: "site-action-reports", element: page(() => import("@/screens/legionella/SiteActionReports")) },
      { id: "water.orphans", path: "orphans", element: page(() => import("@/screens/legionella/Orphans")) },
    ],
  },
  { id: "water.settings", path: "/legionella/settings/:tab?", element: settings },
];
